import { isUndefined } from '../utils/isUndefined.js';
import { isNonEmptyString } from '../utils/isNonEmptyString.js';
import { base } from './base.js';

/**
 * Notification
 * @url http://www.jsonrpc.org/specification#notification
 * @constructor
 * @param {String} method - A String containing the name of the method to be invoked
 * @param {Array|Object} [params] - A Structured value that holds the parameter values to be used during the invocation of the method
 */
function JsonRpcNotification(method, params) {
    if (!(this instanceof JsonRpcNotification)) {
        // @ts-ignore
        return new JsonRpcNotification(method, params);
    }
    if (!isNonEmptyString(method)) {
        throw new TypeError('Notification method must be a non-empty string');
    }
    base(this);
    this.method = method;
    if (!isUndefined(params)) {
        this.params = params;
    }
}

export { JsonRpcNotification };
